import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import Logo from "../../../../../styles/img/custom/renault-top-logo.png";
import {
    UiTopNavBarWr,
    UiMobileNavBar,
    UiHeaderLogo,
} from "./UiTopNavElements";
import UiTopNavItem from "./UiTopNavElements";
// import { userTypes } from "../../../../_redux/_constants/user.constants";
import { isMobile } from "react-device-detect";
// import { socket } from "../../../../../_helpers/support.services";
import { Context } from "../../../../../_context/Store";
import UiChatBot from "../../../chat-bot/UiChatBot";
// import ChatLink from "../../../../../styles/img/chat-link.png"
import NavHelp from "../../../../../styles/img/nav-help-icon.png";
import { createHubConnection } from "../../../../../_helpers/support.services";
import {
    participantJobRoleIds,
    contextApiActions,
    participantTypeIds,
} from "../../../../../_redux/_constants";
import {
    campaignGetAllAreaManagerDealersRequest,
    campaignGetAreaManagerDealersRequest,
    campaignGetParticipantsByDealerRequest,
    campaignVChangeRole,
    getParticipantProfileComplete,
    getParticipantProfileRequest,
    getUSerDetailsRequest,
    userAccountLogUserLogStatusRequest,
    userDeviceRequest,
} from "../../../../../_redux/_actions";
import UiTopNavSelect from "./UiTopNavSelect";
import NavChatButton from "../../../../../styles/img/svg/NavChatButton";
import UiNavbarTopSelect from "../../../../_uiComponents/form/UiNavbarTopSelect";
import UiDealerSelect from "../../UiDealerSelect";

export default function TopNavBar(props) {
    const [isActive, setActive] = useState(false);
    const [topLogo, setToplogo] = useState(true);
    const [whiteLogo, setWhiteLogo] = useState(false);
    const [state, dispatch] = useContext(Context);
    const [selectedDealer, setSelectedDealer] = useState(null);
    const [selectArea, setSelectArea] = useState("15");

    const actionDispatch = useDispatch();
    const navigate = useNavigate();

    const newRef = useRef(null);
    const location = useLocation();

    const {
        userProfileDetails,
        areaManagerDealers,
        isChangeRole,
        allAreaManagerDealers,
    } = useSelector((state) => {
        return {
            userProfileDetails: state.auth.userProfileDetails,
            areaManagerDealers: state.campaign,
            isChangeRole: state.campaign.isChangeRole,
            allAreaManagerDealers: state.campaign.allAreaManagerDealers,
        };
    });

    const jobRoles = [
        { value: 15, label: "Service Manager" },
        { value: 14, label: "Service Advisor" },
        { value: 23, label: "Trade Parts Manager " },
        { value: 20, label: "Service Area Manager " },
        { value: 24, label: "National Manager" },
    ];

    const areas = [
        { value: 11, label: "11" },
        { value: 12, label: "12" },
        { value: 13, label: "13" },
        { value: 14, label: "14" },
        { value: 15, label: "15" },
        { value: 16, label: "16" },
        { value: 17, label: "17 " },
    ];

    const [selectedValue, setSelectedValue] = useState(24);

    const handleChange = (item) => {
        setSelectedValue(item);

        let data = null;

        if (item === 15 || item === 14 || item === 23) {
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                    dealerships: userProfileDetails.dealerships.map(
                        (dealer) => ({
                            ...dealer,
                            dealerCode:
                                selectedDealer !== null
                                    ? selectedDealer?.value
                                    : allAreaManagerDealers?.[0]?.code,
                            dealerName:
                                selectedDealer !== null
                                    ? selectedDealer?.label
                                    : allAreaManagerDealers?.[0]?.name,
                        }),
                    ),
                },
            };
        }
        if (item === 24) {
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                },
            };
        }
        if (item === 20) {
            data = {
                data: {
                    ...userProfileDetails,
                    jobRoleId: item,
                },
            };
        }
        actionDispatch(getParticipantProfileComplete(data));
        actionDispatch(campaignVChangeRole(true));
        dispatch({
            type: "CHANGE_ROLE",
            payload: { changeRole: true },
        });
    };

    const handleAreaChange = (value) => {
        if (location.pathname !== "/app/home") {
            navigate("/app/home");
        }

        setSelectArea(value);
        let data = null;
        data = {
            data: {
                ...userProfileDetails,
                area: value,
            },
        };
        actionDispatch(getParticipantProfileComplete(data));
    };

    const handleChangeDealer = (value) => {
        if (location.pathname !== "/app/home") {
            navigate("/app/home");
        }
        setSelectedDealer(value);
        let data = null;
        data = {
            data: {
                ...userProfileDetails,
                dealerships: userProfileDetails.dealerships.map((dealer) => ({
                    ...dealer,
                    dealerCode: value?.value,
                    dealerName: value?.label,
                })),
            },
        };
        actionDispatch(getParticipantProfileComplete(data));
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    });

    useEffect(() => {
        actionDispatch(getParticipantProfileRequest());
        actionDispatch(getUSerDetailsRequest());
        //actionDispatch(campaignGetParticipantsByDealerRequest({dealerCode: 1}));
        if (location.pathname === "/app/campaigns") {
            if (!auth?.userProfileDetails?.dealerParticipant) {
                navigate("/app/home");
            }
        }

        actionDispatch(
            userDeviceRequest({ devicedUsedTypeId: isMobile ? 1 : 2 }),
        );
        actionDispatch(userAccountLogUserLogStatusRequest({ active: true }));
    }, []);

    const handleOutsideClick = (e) => {
        if (newRef.current && !newRef.current.contains(e.target)) {
            setActive(false);
        }
    };

    const { auth } = useSelector((state) => {
        return {
            auth: state.auth,
        };
    });

    useEffect(() => {
        let connection = null;
        if (typeof auth?.userProfileDetails.userId != "undefined") {
            connection = createHubConnection(auth?.userProfileDetails.userId);

            connection
                .start()
                .then(() => {
                    dispatch({
                        type: contextApiActions.SET_SIGNALR_CONNECTTION,
                        payload: connection,
                    });
                })
                .catch((err) => console.log(err));
        }

        return () => {
            if (connection) {
                connection.stop();
            }
        };
    }, [auth?.userProfileDetails]);

    const mobileSidebarToggle = () => {
        setActive(!isActive);
    };
    const toggleClose = () => {
        setActive(false);
    };
    useEffect(function () {
        window.addEventListener("scroll", () => {
            if (!isMobile) {
                let scrollTop = window.scrollY;
                let activeLink = document.querySelector(
                    ".sb-slider-bottom-line",
                );

                if (activeLink !== null) {
                    if (scrollTop >= activeLink.offsetTop) {
                        setToplogo(false);
                        setWhiteLogo(true);
                    } else {
                        setToplogo(true);
                        setWhiteLogo(false);
                    }
                }
            }
        });
    }, []);

    const showChatBox = () => {
        // setActive(false);
        // dispatch({
        //     type: "CHAT_BOX_MODAL",
        //     payload: {
        //         show: true,
        //         children: <UiChatBot />,
        //     },
        // });
        dispatch({
            type: "FOOTER_CONTENT_MODAL",
            payload: {
                show: true,
                children: (
                    <>
                        <h3 className="sb-chat-support-content">
                            Got a question or need help to get you up and
                            running?
                        </h3>
                        {userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT ? (
                            <h6 className="sb-chat-support-content-email">
                                Message us at: support@rgequipe.com{" "}
                            </h6>
                        ) : (
                            <h6 className="sb-chat-support-content-email">
                                Message us at: support@renaultTLC.com{" "}
                            </h6>
                        )}
                    </>
                ),
            },
        });
    };

    useEffect(() => {
        if (
            auth?.userProfileDetails?.jobRoleId ===
            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER
        ) {
            actionDispatch(
                campaignGetAllAreaManagerDealersRequest({
                    particpantId: auth?.userProfileDetails?.participantIds[0],
                    areaId: null,
                }),
            );
        }
    }, [auth?.userProfileDetails?.jobRoleId]);

    return (
        <>
            <UiMobileNavBar toggle={mobileSidebarToggle} />
            <UiHeaderLogo
                onClick={() => navigate("/app/home")}
                logo={Logo}
                whiteLogo={whiteLogo}
                topLogo={topLogo}
                permission={
                    auth?.userProfileDetails?.roleId ==
                    participantTypeIds.PARTICIPANT
                }
            />

            <UiTopNavBarWr
                isActive={isActive}
                close={toggleClose}
                ref={newRef}
                permission={
                    auth?.userProfileDetails?.jobRoleId ===
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                    auth?.userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT
                }
            >
                <UiTopNavItem
                    onClick={toggleClose}
                    label="Home"
                    pathname={"home"}
                />
                {(auth?.userProfileDetails?.dealerParticipant ||
                    auth?.userProfileDetails.roleId ==
                        participantTypeIds.TLC_PARTICIPANT) && (
                    <UiTopNavItem
                        onClick={toggleClose}
                        label="Campaigns"
                        pathname={"campaigns"}
                    />
                )}

                <UiTopNavItem
                    onClick={toggleClose}
                    label="Shop"
                    pathname={"shop/browse-products"}
                />

                <UiTopNavItem
                    onClick={toggleClose}
                    label="Points Bank"
                    pathname={"/app/points-banking"}
                />
                <UiTopNavItem
                    onClick={toggleClose}
                    label="Voucher Wallet"
                    pathname={"shop/voucher-wallet"}
                />
                <UiTopNavItem
                    onClick={showChatBox}
                    label="Help"
                    externalLink
                    clickEvent
                />
                {(isChangeRole ||
                    auth?.userProfileDetails?.jobRoleId ===
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER) &&
                    (selectedValue === 15 ||
                        selectedValue === 14 ||
                        selectedValue === 23 ||
                        selectedValue === 24 ||
                        selectedValue === 20) && (
                        <>
                            <div
                                className={
                                    selectedValue == 24
                                        ? "sb-top-dealer-select-national-manager sb-top-dealer-mobile-select selected-national-manager"
                                        : "sb-top-dealer-select-national-manager sb-top-dealer-mobile-select"
                                }
                            >
                                <UiNavbarTopSelect
                                    options={jobRoles}
                                    selectRole={true}
                                    onChange={(e) => {
                                        handleChange(e.value);
                                        setActive(false);
                                    }}
                                    defaultValue={{
                                        label: jobRoles[4].label,
                                        value: jobRoles[4].value,
                                    }}
                                />
                            </div>
                            <div className="sb-top-dealer-select-national-manager-sub-options sb-top-dealer-mobile-select">
                                {isChangeRole &&
                                    (selectedValue === 15 ||
                                        selectedValue === 14 ||
                                        selectedValue === 23) && (
                                        <UiDealerSelect
                                            dealerOptions={allAreaManagerDealers.map(
                                                (dealerships) => {
                                                    return {
                                                        value: dealerships.code,
                                                        label: dealerships.name,
                                                    };
                                                },
                                            )}
                                            dealerships={allAreaManagerDealers}
                                            isDashBoard={false}
                                            isAreaManager={false}
                                            selectDealer={true}
                                            onChange={(value) => {
                                                handleChangeDealer(value);
                                                setActive(false);
                                            }}
                                            selectedDealer={selectedDealer}
                                        />
                                    )}
                                {selectedValue === 20 && (
                                    <UiNavbarTopSelect
                                        options={areas}
                                        onChange={(e) => {
                                            handleAreaChange(e.value);
                                            setActive(false);
                                        }}
                                        defaultValue={{
                                            label: areas[0].label,
                                            value: areas[0].value,
                                        }}
                                    />
                                )}
                            </div>
                        </>
                    )}
                {!isChangeRole &&
                    auth?.userProfileDetails?.jobRoleId ===
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                    auth?.userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT && (
                        <div className="sb-top-dealer-mobile-select">
                            <UiTopNavSelect
                                dealerOptions={auth?.userProfileDetails?.dealerships.map(
                                    (dealerships) => {
                                        return {
                                            value: dealerships.dealerCode,
                                            label: dealerships.dealerName,
                                        };
                                    },
                                )}
                                selectDealer={true}
                                dealerships={
                                    auth?.userProfileDetails?.dealerships
                                }
                            />
                        </div>
                    )}
            </UiTopNavBarWr>
            <div
                className={
                    auth?.userProfileDetails?.jobRoleId ===
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                    auth?.userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT
                        ? "sb-chat-bot-with-dealer"
                        : "sb-chat-bot-with-no-dealer"
                }
            >
                <div
                    className={
                        isChangeRole ||
                        auth?.userProfileDetails?.jobRoleId ===
                            participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER
                            ? "sb-show-chat-bot-manager"
                            : "sb-show-chat-bot"
                    }
                    onClick={showChatBox}
                >
                    <NavChatButton />
                </div>
            </div>

            {(isChangeRole ||
                auth?.userProfileDetails?.jobRoleId ===
                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER) &&
                (selectedValue === 15 ||
                    selectedValue === 14 ||
                    selectedValue === 23 ||
                    selectedValue === 24 ||
                    selectedValue === 20) && (
                    <>
                        <div
                            className={
                                selectedValue == 24
                                    ? "sb-top-dealer-select-national-manager selected-national-manager"
                                    : "sb-top-dealer-select-national-manager "
                            }
                        >
                            <UiNavbarTopSelect
                                options={jobRoles}
                                selectRole={true}
                                onChange={(e) => {
                                    handleChange(e.value);
                                }}
                                defaultValue={{
                                    label: jobRoles[4].label,
                                    value: jobRoles[4].value,
                                }}
                            />
                        </div>
                        <div className="sb-top-dealer-select-national-manager-sub-options">
                            {isChangeRole &&
                                (selectedValue === 15 ||
                                    selectedValue === 14 ||
                                    selectedValue === 23) && (
                                    <UiDealerSelect
                                        dealerOptions={allAreaManagerDealers.map(
                                            (dealerships) => {
                                                return {
                                                    value: dealerships.code,
                                                    label: dealerships.name,
                                                };
                                            },
                                        )}
                                        dealerships={allAreaManagerDealers}
                                        isDashBoard={false}
                                        isAreaManager={false}
                                        selectDealer={true}
                                        onChange={(value) => {
                                            handleChangeDealer(value);
                                        }}
                                        selectedDealer={selectedDealer}
                                    />
                                )}
                            {selectedValue === 20 && (
                                <UiNavbarTopSelect
                                    options={areas}
                                    onChange={(e) => {
                                        handleAreaChange(e.value);
                                    }}
                                    defaultValue={{
                                        label: areas[0].label,
                                        value: areas[0].value,
                                    }}
                                />
                            )}
                        </div>
                    </>
                )}

            {!isChangeRole &&
                auth?.userProfileDetails?.jobRoleId ===
                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
                auth?.userProfileDetails.roleId ==
                    participantTypeIds.PARTICIPANT && (
                    <div className="sb-top-dealer-select">
                        <UiTopNavSelect
                            dealerOptions={auth?.userProfileDetails?.dealerships.map(
                                (dealerships) => {
                                    return {
                                        value: dealerships.dealerCode,
                                        label: dealerships.dealerName,
                                    };
                                },
                            )}
                            selectDealer={true}
                            dealerships={auth?.userProfileDetails?.dealerships}
                        />
                    </div>
                )}
        </>
    );
}
